<script>
import { ref, onMounted, watch } from 'vue';

import {
  LpTooltip,
} from '@thehotelsnetwork/lampo';

import useUserState from '@/state/useUserState';
import useDebugState from '@/state/useDebugState';
import checkCanCreateCompsets from '@/utils/checkCanCreateCompsets';

export default {
  components: {
    LpTooltip,
  },
  setup() {
    const showTooltip = ref(false);
    const loading = ref(true);
    const disabled = ref(true);
    const { isStrictlyDMOUser } = useUserState();
    const { overrideCompsetsLimit } = useDebugState();
    const infoMessage = isStrictlyDMOUser.value
      ? 'You’ve reached your limit for Destinations. Contact us to upgrade your limit.'
      : 'You’ve reached your limit for Custom Compsets and Destinations. Contact us to upgrade your limit.';

    onMounted(async () => {
      disabled.value = !await checkCanCreateCompsets();

      loading.value = false;
    });

    watch(overrideCompsetsLimit, () => {
      disabled.value = !overrideCompsetsLimit.value;
    });

    return {
      showTooltip,
      loading,
      infoMessage,
      disabled,
    };
  },
};
</script>

<template>
  <LpTooltip
    v-model="showTooltip"
    size="small"
    mode="manual"
    placement="top"
    :max-width="260"
    :min-width="260"
    @mouseover="showTooltip = disabled"
    @mouseleave="showTooltip = false"
  >
    <template #trigger>
      <slot
        :disabled="disabled"
        :loading="loading"
      />
    </template>
    <template
      #tooltip
    >
      {{ $t(infoMessage) }}
    </template>
  </LpTooltip>
</template>
